var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9669 10.5983V3.24369C12.9669 2.12669 12.0608 1.22054 10.9438 1.22054C9.82677 1.22054 8.92188 2.12669 8.92188 3.24369V9.31064",
    stroke: "url(#paint0_linear_1180_974)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7265 14.8253L18.4575 5.72359C18.5334 5.4712 18.5585 5.20622 18.5311 4.94407C18.5037 4.68192 18.4245 4.42783 18.298 4.19659C18.1715 3.96534 18.0003 3.76156 17.7943 3.59709C17.5884 3.43262 17.3518 3.31075 17.0983 3.23857C16.8462 3.16673 16.5824 3.14542 16.322 3.17586C16.0617 3.2063 15.8099 3.2879 15.5812 3.41596C15.3525 3.54402 15.1513 3.71602 14.9893 3.92207C14.8273 4.12812 14.7076 4.36416 14.6371 4.61662L12.9679 10.5957M4.77483 10.3184L6.09892 13.2564C6.30356 13.7428 6.31009 14.2899 6.1171 14.781C5.9241 15.2721 5.54687 15.6684 5.06585 15.8853C4.58483 16.1023 4.03809 16.1227 3.54223 15.9422C3.04637 15.7618 2.64064 15.3948 2.41156 14.9194L1.08496 11.9813C0.975769 11.739 0.915368 11.4776 0.907205 11.212C0.899042 10.9464 0.943278 10.6817 1.03739 10.4332C1.22745 9.93128 1.60911 9.52542 2.09842 9.3049C2.58773 9.08437 3.1446 9.06726 3.64652 9.25732C4.14844 9.44738 4.55431 9.82905 4.77483 10.3184Z",
    stroke: "url(#paint1_linear_1180_974)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91924 14.0986C10.1764 13.3861 10.1458 12.6014 9.8339 11.911L8.48722 8.924C8.3796 8.68541 8.22592 8.47041 8.03501 8.29136C7.8441 8.1123 7.6197 7.97271 7.37471 7.88059C7.12971 7.78846 6.86894 7.74563 6.60735 7.75454C6.34576 7.76345 6.0885 7.82393 5.85034 7.93251C5.60842 8.04288 5.3911 8.20066 5.21124 8.39652C5.03138 8.59238 4.89264 8.82233 4.80324 9.07276C4.71383 9.32319 4.67558 9.58901 4.69073 9.85449C4.70589 10.12 4.77415 10.3797 4.89148 10.6183L5.06091 10.9647",
    stroke: "url(#paint2_linear_1180_974)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6007 20.8956L13.2182 19.6607C13.2328 19.6317 13.2408 19.5999 13.2416 19.5675C13.2425 19.5352 13.2363 19.503 13.2234 19.4733C13.2104 19.4436 13.1911 19.4171 13.1668 19.3957C13.1425 19.3743 13.1138 19.3585 13.0827 19.3494L8.6272 18.0391C8.19469 17.9112 7.82054 17.636 7.56956 17.2613C7.31858 16.8865 7.20656 16.4358 7.25291 15.9871C7.30589 15.4824 7.5556 15.019 7.94792 14.6971C8.34023 14.3753 8.84357 14.221 9.34886 14.2677L15.3581 14.8274C15.3581 14.8274 20.1399 15.5629 18.4832 20.3434C16.829 25.1252 16.278 26.7794 12.6007 26.7794H6.34927C4.93504 26.779 3.57883 26.2171 2.57882 25.2171C1.57881 24.2171 1.01686 22.8608 1.01652 21.4466L0.832031 11.1501",
    stroke: "url(#paint3_linear_1180_974)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_974",
    x1: 8.84848,
    y1: 6.10616,
    x2: 13.0329,
    y2: 6.10616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_974",
    x1: 0.586281,
    y1: 9.88397,
    x2: 18.8293,
    y2: 9.88397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_974",
    x1: 4.58944,
    y1: 11.0591,
    x2: 10.1803,
    y2: 11.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_974",
    x1: 0.505451,
    y1: 19.2926,
    x2: 19.1254,
    y2: 19.2926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.fa95d9ca3524412ca14d4486adef75f7.svg";
export { ForwardRef as ReactComponent };